import { gql, useQuery } from '@apollo/client';
import type { Company, QueryCompaniesWithFilterArgs } from '@/types/GraphqlSchema';

const QUERY = gql`
  query companiesWithFilter(
    $search: String
    $assets: [JSON!]
    $countries: [String!]
    $basins: [String!]
    $activeInBlocks: Boolean!
    $activeInLeases: Boolean!
    $includeHistoricalParticipants: Boolean!
    $nonOperator: Boolean!
    $operator: Boolean!
    $maBuyers: Boolean
    $maSellers: Boolean
    $isMAndAOpportunity: Boolean
    $pagination: PaginationInput
  ) {
    companiesWithFilter(
      search: $search
      assets: $assets
      countries: $countries
      basins: $basins
      activeInBlocks: $activeInBlocks
      activeInLeases: $activeInLeases
      includeHistoricalParticipants: $includeHistoricalParticipants
      nonOperator: $nonOperator
      operator: $operator
      maBuyers: $maBuyers
      maSellers: $maSellers
      isMAndAOpportunity: $isMAndAOpportunity
      pagination: $pagination
    ) {
      companies {
        id
        name
      }
      totalCount
    }
  }
`;

type UseGetCompaniesParams = {
  variables?: QueryCompaniesWithFilterArgs;
  skip?: boolean;
};

type UseGetCompaniesReturn = {
  companies: Company[];
  totalCount: number;
  loading: boolean;
  error: Error | undefined;
};

export const useGetCompanies = ({
  variables = { search: '', maBuyers: false, maSellers: false },
  skip = false,
}: UseGetCompaniesParams = {}): UseGetCompaniesReturn => {
  const { data, loading, error } = useQuery(QUERY, {
    variables: {
      search: variables.search || '',
      assets: variables.assets || [],
      countries: variables.countries || [],
      basins: variables.basins || [],
      activeInBlocks: variables.activeInBlocks || false,
      activeInLeases: variables.activeInLeases || false,
      includeHistoricalParticipants: variables.includeHistoricalParticipants || false,
      nonOperator: variables.nonOperator || false,
      operator: variables.operator || false,
      maBuyers: variables.maBuyers || false,
      maSellers: variables.maSellers || false,
      isMAndAOpportunity: variables.isMAndAOpportunity || false,
      pagination: variables.pagination || { page: 1, perPage: 50 },
    },
    skip,
  });

  return {
    companies: data?.companiesWithFilter?.companies || [],
    totalCount: data?.companiesWithFilter?.totalCount || 0,
    loading,
    error,
  };
};
